import DayInactivityIntervalsListPage from './DayInactivityIntervalsListPage.vue';
import DayInactivityIntervalsListTable from './DayInactivityIntervalsListTable.vue';

export * from './types';

export {
    DayInactivityIntervalsListPage as default,
    DayInactivityIntervalsListPage,
    DayInactivityIntervalsListTable
};
